import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";
import {translate} from "../../../../../components/translate/translate.jsx";

const AlarmSourceContent = ({ data }) => {
    const origin = data?.apply?.origin;
    const hasMultipleOrigins = origin.length > 1;

    useEffect(() => {
        if (!hasMultipleOrigins) return;

        const values = [];
        const labels = [];

        origin.forEach((element) => {
            labels.push(translate(element.text));
            values.push(element.qty);
        });

        GraphicUtils.barChart("alarmSource", values, labels, false);
        ReportUtils.createExportableTable(labels, values, "Origem dos alarmes", null, ["Origem", "Quantidade"])
    }, [origin, hasMultipleOrigins]);

    if (!hasMultipleOrigins) return null;

    return (
        <>
            <div className="chart-report">
                <span className="chart-title">Origem dos alarmes</span>
                <div id="alarmSource"/>
                <span className="obs-warn">* Alarmes com mais de uma Origem serão contabilizados uma vez para cada Origem.</span>
            </div>

            <div className="chart-divisor print-hide"></div>
        </>
    )
};

export default AlarmSourceContent;